module.exports = __webpack_public_path__ + "assets/img/404_bg.025da298.png";